import Link from 'next/link';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { AppleIcon } from '../icons/AppleIcon';
import { WindowsIcon } from '../icons/WindowsIcon';
import {
  OperatingSystemRequirementsWithDownload,
  DownloadGameDialogProps,
} from './DownloadGameDialog';
import { DownloadGameCover } from './DownloadGameCover';
import { DownloadGameSpecs } from './DownloadGameSpecs';
import { GradientTypography } from '../gradients/GradientTypography';

export type DownloadGameInfoProps = Pick<
  DownloadGameDialogProps,
  'title' | 'version'
> &
  OperatingSystemRequirementsWithDownload;

export function DownloadGameInfo({
  name,
  version,
  coverImageUrl,
  requirements,
  downloadUrl,
}: DownloadGameInfoProps) {
  return (
    <>
      <Box>
        <GradientTypography
          sx={{
            textTransform: 'uppercase',
          }}
          variant="h5"
          gradientColor="primary.vertical"
        >
          {name}
        </GradientTypography>
        <Typography color="text.secondary" variant="body1">
          Version number {version}
        </Typography>
      </Box>
      <DownloadGameCover imageUrl={coverImageUrl} />
      <DownloadGameSpecs {...requirements.recommendedRequirements} />
      <Link href={downloadUrl} target="_blank">
        <Button
          variant="contained"
          startIcon={
            name === 'MAC' ? (
              <AppleIcon />
            ) : name === 'WINDOWS' ? (
              <WindowsIcon />
            ) : undefined
          }
        >
          Download
        </Button>
      </Link>
    </>
  );
}
